import React from 'react';
import { Text } from '@moda/om';
import { formatPrice } from '@moda/portal-stanchions';
import { ShippingMethod } from '../../../hooks/useCart/cart.rest';

import './ShippingMethodPreviewCharges.scss';

interface Props {
  option: ShippingMethod | undefined;
}

export const ShippingMethodPreviewCharges: React.FC<Props> = ({ option }) => (
  <Text className="ShippingMethodPreviewCharges">
    {option?.charges == 0 || option?.freeShipping
      ? 'Free'
      : formatPrice(option?.currency, option?.charges)}
  </Text>
);
